module.exports = __webpack_public_path__ + "static/media/tugbaBeauty.8a11a1bc.png";